export class MapEditHistory<T> {
  private states: string[] = [];
  private cursor = -1;
  private initial = '';
  constructor(
    private maxEntries = 30,
    private maxChars = 16 * 1024 * 1024
  ) {}

  reset(state: T) {
    this.initial = JSON.stringify(state);
    this.states = [this.initial];
    this.cursor = 0;
  }
  record(state: T) {
    if (this.cursor < 0) return;
    const next = JSON.stringify(state);
    if (next === this.states[this.cursor]) return;
    this.states = this.states.slice(0, this.cursor + 1);
    this.states.push(next);
    let size = this.states.reduce((sum, value) => sum + value.length, 0);
    while (this.states.length > 2 && (this.states.length > this.maxEntries || size > this.maxChars)) {
      size -= this.states.shift()!.length;
    }
    this.cursor = this.states.length - 1;
  }
  get canUndo() {
    return this.cursor > 0;
  }
  get canRedo() {
    return this.cursor >= 0 && this.cursor < this.states.length - 1;
  }
  get dirty() {
    return this.cursor >= 0 && this.states[this.cursor] !== this.initial;
  }
  undo(): T | null {
    return this.canUndo ? JSON.parse(this.states[--this.cursor]) : null;
  }
  redo(): T | null {
    return this.canRedo ? JSON.parse(this.states[++this.cursor]) : null;
  }
}
